<template>
  <mailchimp-subscribe
    url="https://traitlabs.us4.list-manage.com/subscribe/post-json"
    user-id="a088f0887b8241f6f59cfe79f"
    list-id="16fa2c015e"
    @error="onError"
    @success="onSuccess"
  >
    <template v-slot="{ subscribe, setEmail, error, success, loading }">
      <form @submit.prevent="subscribe">
        <input class="form-control" type="email" placeholder="Email address" v-if="!success" @input="setEmail($event.target.value)" />        
        <div class="alert alert-error" v-if="error">{{ error }}</div>
        <div class="alert alert-success" v-if="success">Subscribed succesfully!</div>
        <button type="submit" class="btn btn-md btn-primary" v-if="!success">Submit</button>
      </form>
    </template>
  </mailchimp-subscribe>
</template>

<script>
import MailchimpSubscribe from 'vue-mailchimp-subscribe'

export default {
  components: {
    MailchimpSubscribe,
  },
  methods: {
    onError() {
      this.$toast.open({
        message: "Error"
      });
    },
    onSuccess() {
      // handle success
    },
  },
}
</script>